// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"307":"7973d6de","468":"4f4d0694","562":"8aa8be1d","581":"ec3ce48c","723":"6ecaf90b","726":"cf0057c4"}[chunkId] + ".js";
};